var EstimateMixin =  {
    data() {
        return {
            labels: {
                accepted: {
                    label: this.$l10n.__("En attente de facturation"),
                    labelCount: this.$l10n.__("Devis")
                },
                expired: {
                    label: this.$l10n.__("Expiré"),
                    labelCount: this.$l10n.__("Devis")
                },
                sent: {
                    label: this.$l10n.__("En attente de validation"),
                    labelCount: this.$l10n.__("Devis")
                }
            },
            settingsFormName : 'estimate-setting-form'
        }
    },
}
export default EstimateMixin;